import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const style = {
  main: {
    minHeight: 50,
    width: '100%',
    backgroundColor: ColorSF2.white,
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'start',
    padding: 10,
    borderBottom: `1px solid ${ColorSF2.mediumGray}`,
  },
  executeBox: {
    display: 'flex',
    alignItems: 'center',
  },
  selectBox: {
    marginLeft: 10,
  },
  executeButton: {
    width: 59,
    height: 31,
    borderRadius: 5,
    marginLeft: 10,
    backgroundColor: ColorSF2.green,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: ColorSF2.white,
    cursor: 'pointer',
    fontSize: 14,
  },
  disabledButton: {
    width: 59,
    height: 31,
    borderRadius: 5,
    marginLeft: 10,
    backgroundColor: ColorSF2.lightGray,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    fontSize: 14,
  },
  allCheckArea: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: 20,
  },
  checkArea: {
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  defaultCheckBox: {
    display: 'none',
  },
  checkboxArea: {
    width: 14,
    height: 14,
  },
  checkboxLabel: {
    width: 14,
    height: 14,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  postButton: {
    width: 80,
    height: 31,
    borderRadius: 5,
    margin: 'auto',
    padding: '0px 10px',
    backgroundColor: '#FFFFFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#1F1F2C',
    cursor: 'pointer',
    fontSize: '14px',
    whiteSpace: 'nowrap',
  },
};

export const SelectExecute = styled.select`
  color: #777777;
  &.selected {
    color: #414141;
  }
`;

export const TabWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 10px;
`;

export const TabTitle = styled.div`
  width: 100px;
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Tab = styled.button`
  flex: 1;
  white-space: nowrap;
  border: none;
  cursor: pointer;
  width: 70px;
  height: 30px;
  font-size: 1rem;
  background-color: ${props =>
    props.active ? ColorSF2.skyBlue : ColorSF2.paleBlue};
  &:hover {
    background-color: ${ColorSF2.skyBlue};
  }
`;
